export function translateRole(value) {
  const tranlatedRoles = {
    EXECUTIVE_MANAGER: "Δήμαρχος",
    MANAGER: "Διευθυντής",
    CHIEF: "Προϊστάμενος",
    EMPLOYEE: "Υπάλληλος",
  };
  return tranlatedRoles[value];
}
